import { jsx } from "react/jsx-runtime";
import { useState, useMemo, createContext, useContext, useEffect, useRef } from "react";
import { useFocusedField } from "./focused-field-provider.js";
const EventsContext = createContext(void 0);
const EventsProvider = ({ children }) => {
  const [submitSuccessCounter, setSubmitSuccessCounter] = useState(0);
  const [submittedValues, setSubmittedValues] = useState({});
  const value = useMemo(
    () => ({
      submitSuccessCounter,
      submittedValues,
      fireSubmitSuccess: (values) => {
        setSubmitSuccessCounter((previous) => previous + 1);
        setSubmittedValues(values || {});
      }
    }),
    [submitSuccessCounter, submittedValues]
  );
  return /* @__PURE__ */ jsx(EventsContext.Provider, { value, children });
};
const useEvents = () => {
  const context = useContext(EventsContext);
  if (context === void 0) {
    throw new Error("useEvents must be used within a EventsProvider");
  }
  return context;
};
const useSubmitSuccessTrigger = () => {
  const { fireSubmitSuccess } = useEvents();
  return fireSubmitSuccess;
};
const useSubmitSuccessEvent = (onSubmitSuccess) => {
  const { submitSuccessCounter, submittedValues = {} } = useEvents();
  const previousCounter = useRef(submitSuccessCounter);
  useEffect(() => {
    if (previousCounter.current !== submitSuccessCounter) {
      previousCounter.current = submitSuccessCounter;
      onSubmitSuccess(submittedValues);
    }
  }, [submitSuccessCounter, onSubmitSuccess, submittedValues]);
};
const useFocusGroupFieldEvent = (groupFieldId, getFocusedChildFieldId) => {
  const { focusedFieldId, setFocusedFieldId } = useFocusedField();
  useEffect(() => {
    if (groupFieldId && focusedFieldId === groupFieldId) {
      const fieldId = getFocusedChildFieldId();
      if (fieldId) {
        setFocusedFieldId(fieldId);
      }
    }
  }, [groupFieldId, focusedFieldId, setFocusedFieldId]);
};
const useFocusFieldEvent = (onFocusField, fieldId) => {
  const { focusedFieldId, setFocusedFieldId } = useFocusedField();
  useEffect(() => {
    if (fieldId && focusedFieldId && focusedFieldId === fieldId) {
      onFocusField();
      setFocusedFieldId(void 0);
    }
  }, [fieldId, focusedFieldId, setFocusedFieldId]);
};
export {
  EventsProvider,
  useFocusFieldEvent,
  useFocusGroupFieldEvent,
  useSubmitSuccessEvent,
  useSubmitSuccessTrigger
};
//# sourceMappingURL=events-context.js.map
